import PathoRiskText from './PathoRiskText';
import WatchlistButtonGroup from './Complex/WatchlistButtonGroup';
import MendelianCard from './Mendelian/MendelianCard';
import ComplexCard from './Complex/ComplexCard';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import Grid from '@mui/material/Grid';


export default function SectionPathoRisk() {

    
    return (

    <SectionStructure
    
            sectiontext=    { <PathoRiskText /> }
            sectiondiagroup=    { <WatchlistButtonGroup />} 

            sectioncards=  {<>

                <Grid container>
                       <Grid size={{xs:12, xl:6 }} sx={{display:'flex', justifyContent:'center', alignItems: 'flex-start' }}> <MendelianCard /> </Grid> 
                       <Grid size={{xs:12, xl:6 }} sx={{display:'flex', justifyContent:'center', alignItems: 'flex-start'}}> <ComplexCard /> </Grid> 
                </Grid>
            
            </> }
        />
    )
}